import React from 'react'
import { CollectionContext } from '@morningtrain/react-resources'
import useCartContent from 'services/cart/hooks/use-cart-content'

function CartContentCollection (props) {
  const cartContent = useCartContent()

  return (
    <CollectionContext.Provider value={cartContent}>
      {props.children}
    </CollectionContext.Provider>
  )
}

export default CartContentCollection
